import * as React from 'react'

import getConfig from 'next/config'

import { CmsComponentSlot } from '@grandvisionhq/bloomreach'
import { Container } from '@grandvisionhq/elements'
import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../cms'

const { publicRuntimeConfig } = getConfig()
const appointmentUrl = publicRuntimeConfig.grandvision.appointmentUrl || ''

type InitialProps = {
  queryParams?: Record<string, string | string[]>
}

type Props = InitialProps

const AppointmentPage: NextPage<Props, InitialProps> = ({ queryParams = {} }) => {
  const { storeId, postalCode } = queryParams
  const paramObject = { shop: storeId || '', postnr: postalCode || '', search: true }
  const params = Object.entries(paramObject)
    .map(([key, val]) => `${key}=${val}`)
    .join('&')
  const iframeSrc = encodeURI(`${appointmentUrl}${params ? '?' + params : ''}`)

  if (!appointmentUrl) {
    console.error('No valid appointmentUrl supplied!')
  }

  return (
    <>
      <CmsComponentSlot path="main/top-container" />
      <Container className="appointment">
        {appointmentUrl && (
          <iframe
            className="appointment__iframe"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
            scrolling="false"
            src={iframeSrc}
            title="Appointment"
          />
        )}
      </Container>
      <CmsComponentSlot path="main/bottom-container" />
    </>
  )
}

AppointmentPage.getInitialProps = ({ query }) => ({
  queryParams: query,
})

export default compose(withCms(), withLayout())(AppointmentPage)
